import React from 'react'
import style from "css/app.module.css"

/**
 * 파일명: Wrapper.js
 * 작성자: 권도훈
 * 작성일자: 23.04.06
 * 설명: app Wrapper
 */
function Wrapper({ isOpen, children }) {
    return (
        <div
            className={
                isOpen
                    ? style.main_wrapper
                    : `${style.main_wrapper} ${style.close}`
            }
        >
            {children}
        </div>
    )
}

export default Wrapper
